import React from "react";

const AdminGuardiasDetailModal = ({
  isOpen,
  onClose,
  fecha,
  franja,
  detalle,
  loading,
  error,
}) => {
  if (!isOpen) {
    return null;
  }

  const ausencias = detalle?.ausencias || [];
  const profesoresGuardia = detalle?.profesoresGuardia || [];
  const sortedAusencias = [...ausencias].sort((a, b) => {
    const nombreA = a?.profesorGuardia?.nombre || "";
    const nombreB = b?.profesorGuardia?.nombre || "";
    return nombreA.localeCompare(nombreB, "es", { sensitivity: "base" });
  });
  const guardiaBadgeColors = [
    "#0d6efd",
    "#6610f2",
    "#198754",
    "#dc3545",
    "#fd7e14",
    "#20c997",
    "#6f42c1",
    "#0dcaf0",
    "#6c757d",
    "#d63384",
  ];
  const getGuardiaBadgeColor = (nombre) => {
    if (!nombre) return guardiaBadgeColors[0];
    let hash = 0;
    for (let i = 0; i < nombre.length; i += 1) {
      hash = (hash * 31 + nombre.charCodeAt(i)) % guardiaBadgeColors.length;
    }
    return guardiaBadgeColors[hash];
  };
  const isAusenciaApoyo = (ausencia) => {
    if (!ausencia) return false;
    if (ausencia.apoyo === true || ausencia.esApoyo === true) return true;
    const tipoCandidates = [
      ausencia.tipo,
      ausencia.tipoAusencia,
      ausencia.tipoGuardia,
      ausencia.tipoAusencia?.nombre,
      ausencia.tipoGuardia?.nombre,
    ].filter(Boolean);
    return tipoCandidates.some(
      (value) => typeof value === "string" && value.toLowerCase().includes("apoyo")
    );
  };

  return (
    <div
      className="modal fade show"
      id="modalDetalleGuardiaAdmin"
      tabIndex="-1"
      aria-modal="true"
      style={{ display: "block", marginTop: "6rem" }}
    >
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">Detalle de guardias</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} />
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <strong>Fecha:</strong> {fecha}{" "}
              {franja && (
                <span className="ms-2">
                  <strong>Franja:</strong> {franja.descripcion} ({franja.horaInicio} - {franja.horaFin})
                </span>
              )}
            </div>

            {loading && <div className="alert alert-info">Cargando detalle...</div>}
            {error && <div className="alert alert-danger">{error}</div>}

            {!loading && !error && (
              <>
                <h6 className="mb-2">Ausencias y asignaciones</h6>
                {ausencias.length == 0 ? (
                  <div className="alert alert-light">No hay ausencias registradas en esta franja.</div>
                ) : (
                  sortedAusencias.map((ausencia) => (
                    <div key={ausencia.id} className="card mb-2 border-light">
                      <div className="card-body p-2">
                        <div className="d-flex align-items-center gap-2 fw-bold">
                          <span>{ausencia.profesor?.nombre || "Profesor sin nombre"}</span>
                          {isAusenciaApoyo(ausencia) && (
                            <span className="badge bg-warning text-dark">Apoyo</span>
                          )}
                        </div>
                        <div className="small text-muted">
                          <strong>Aula origen:</strong> {ausencia.celdaHoraria?.aula?.codigo || "Sin aula"}
                        </div>
                        <div className="small text-muted">
                          <strong>Aula destino:</strong>{" "}
                          {ausencia.aulaDestino?.codigo || "Sin aula destino"}{" "}
                          {ausencia.aulaDestino?.descripcion ? `(${ausencia.aulaDestino.descripcion})` : ""}
                        </div>
                        <div className="small text-muted">
                          <strong>Grupos:</strong> {ausencia.celdaHoraria?.grupos || "Sin grupos"}
                        </div>
                        {ausencia.profesorGuardia && (
                          <div className="mt-1">
                            <span
                              className="badge"
                              style={{
                                backgroundColor: getGuardiaBadgeColor(ausencia.profesorGuardia.nombre),
                              }}
                            >
                              Guardia: {ausencia.profesorGuardia.nombre}
                            </span>
                          </div>
                        )}
                        <div className="mt-1">
                          {ausencia.firmada ? (
                            <span className="badge bg-success">Firmada</span>
                          ) : (
                            <span className="badge bg-danger">No firmada</span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                )}

                <div className="mt-4">
                  <h6 className="mb-2">Profesores de guardia en esta franja</h6>
                  {profesoresGuardia.length == 0 ? (
                    <div className="alert alert-light">
                      No hay profesores de guardia configurados para esta franja.
                    </div>
                  ) : (
                    <ul className="list-group list-group-flush">
                      {profesoresGuardia.map((profesor) => (
                        <li
                          key={profesor.id}
                          className="list-group-item d-flex justify-content-between align-items-center py-2"
                        >
                          <span>{profesor.nombre}</span>
                          <span className="d-flex align-items-center gap-2">
                            {profesor.ausente && <span className="badge bg-danger">Ausente</span>}
                            <span className="badge bg-primary">({profesor.contadorGuardias})</span>
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminGuardiasDetailModal;
